// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
/*const firebaseConfig = {
  apiKey: "AIzaSyDUThNWlKqbqsqIcTb8RdXaQ8PEVXymm8w",
  authDomain: "scb-web-d7866.firebaseapp.com",
  projectId: "scb-web-d7866",
  storageBucket: "scb-web-d7866.appspot.com",
  messagingSenderId: "929736639694",
  appId: "1:929736639694:web:99cce681c17d71e6d9fc9f",
};*/
let firebaseConfig = {};
if (process.env.NODE_ENV === "development") {
  firebaseConfig = {
    apiKey: "AIzaSyCOC2O1o0-Qrp_PJZVNF9EVRHzbeTl9FCA",
    authDomain: "pruebas-92c1e.firebaseapp.com",
    projectId: "pruebas-92c1e",
    storageBucket: "pruebas-92c1e.firebasestorage.app",
    messagingSenderId: "951392602628",
    appId: "1:951392602628:web:3b54c9deefb0cc07e60351",
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyDUThNWlKqbqsqIcTb8RdXaQ8PEVXymm8w",
    authDomain: "scb-web-d7866.firebaseapp.com",
    projectId: "scb-web-d7866",
    storageBucket: "scb-web-d7866.firebasestorage.app",
    messagingSenderId: "929736639694",
    appId: "1:929736639694:web:99cce681c17d71e6d9fc9f",
  };
}
//console.log('value:',firebaseConfig)
//console.log(process.env.NODE_ENV);
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default getFirestore(app);
